<label *ngIf="label"
  [attr.for]="id"
  soho-label
    [required]="required$ | async"
  lm-label
    [layoutField] = "field"
    [personalize]="personalize"
  lm-text-style
    [textStyle]="field?.label?.textStyle"
>{{triggerValueChange | async | formatLabelRule:field:labelResourceValue:model:specFields}}<ng-container *ngTemplateOutlet="mouseOverTextTemplate"></ng-container>
</label>
<div
  lm-field-options
    [hasContextMenu]="insertContextMenu"
    [ajaxCallbackFunction]="onBeforeContextMenuOpen"
    [contextMenuEventFunction]="contextMenuClicked"
    [lmParagraphLayoutInfo]="lmParagraphLayoutInfo"
    [buttonId]="fieldOptionsId"
    [fieldOptionsLabel]="fieldOptionsLabel | translate : fieldNameForOptionsMenu"
    [isInAccessibilityMode]="isInAccessibilityMode"
    [displayFieldOptions]="displayFieldOptions"
    [fieldAutomationId]="fieldAutomationId"
  soho-tooltip
    [popover]="true"
    [title]="popoverTitle"
    [placement]="'bottom'"
    [trigger]="'click'"
  [ngClass]="{'lm-is-display-as-text': displayAsText}"
  (contextmenu)="onContextMenu($event)"
  (focusin)="onFieldFocus($event)"
  (focusout)="onFieldBlur($event)">
  <ng-container [ngSwitch]="displayType">
    <textarea *ngSwitchCase="layoutDisplayType.PLAIN"
      #Input
      [ngClass]="fieldClassesString"
      [attr.id]="id"
      [attr.aria-label]="field?.label?.nolabel && bindId"
      [attr.tabindex]="isInAccessibilityMode ? 0 : (readOnly$ | async) ? -1 : null"
      [attr.bindId]="bindId"
      [attr.readonly]="(readOnly$ | async) ? true : null"
      [attr.aria-describedby]="(required$ | async) ? fieldDescriptionId : null"
      [(ngModel)]="modelField.value"
      lm-displayupper
        [isUpperCase]="isUpperCase"
      lm-field-style
        [specField]="specField"
        [fieldStyle]="layoutObject?.fieldStyle"
        [recalculateStyles]="triggerValueChange | async"
      soho-textarea
        [characterCounter]="false"
        [maxlength]="maxLength"
        [rows]="rows"
      soho-alert
      soho-trackdirty
        (dirty)="onDirty($event)"
        (pristine)="onPristine($event)"
        (afterResetDirty)="onAfterResetDirty($event)"
      soho-input-validate
        (error)="onError($event)"
        (valid)="onValid($event)"
      (blur)="onBlur($event)"
      (input)="onInput($event)"
    ></textarea>
    <p *ngSwitchCase="layoutDisplayType.DISPLAY_AS_TEXT"
        [attr.id]="id"
        [attr.tabindex]="isInAccessibilityMode ? 0 : null"
        [ngClass]="fieldClassesString"
        [class.personalize-text]="personalize"
        [ngStyle]="{ '-webkit-line-clamp': layoutObject?.lines }"
        soho-alert
        lm-field-style
          [specField]="specField"
          [fieldStyle]="layoutObject?.fieldStyle"
          [recalculateStyles]="triggerValueChange | async"
    >{{modelField.valueChanged | async | formatMessageRule:true:field.text:model:specFields}}</p>
    <ng-container *ngIf="showBarCodeIcon">
      <lm-scan-options
          [hasContextMenu]="false"
          [displayScanOptions]="false"
          (click)="onBarCodeClick()"
      ></lm-scan-options>
    </ng-container>
  </ng-container>
</div>

<ng-template #mouseOverTextTemplate>
  <ng-container *ngIf="layoutObject.mouseOverText">
    <lm-mouse-over-text
        [beforeShowTooltip]="displayMouseOverText"
    ></lm-mouse-over-text>
  </ng-container>
</ng-template>

<span [id]="fieldDescriptionId" class="audible">{{ (required$ | async) ? ('Required' | translate) : '' }}</span>